module.exports = __webpack_public_path__ + "img/shape-7_gray-100.7d0433c.png";